<template>
    <form class="box">
      <div class="columns is-multiline">
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Provider ID (Short format - e.g. 1-1-1, 3-4-5 )</span>
          <div class="field">
            <bulma-input name="provider_id" :hasError="!meLessonFormat(lesson.additionalInfo.provider_id, false)"  v-model="lesson.additionalInfo.provider_id" rules="required" placeholder='Provider id'/>
            <transition name="fade-fast">
              <span v-show="!meLessonFormat(lesson.additionalInfo.provider_id, false)" class="help is-danger">Wrong format</span>
            </transition>
            <span>Example: 1-1-1, 2-3-11, 5-2-4, etc.</span>
          </div>
        </div>
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Provider full ID (e.g. L1-U1-L1, L2-U3-L11)</span>
          <div class="field">
            <bulma-input name="provider_full_id" :hasError="!meLessonFormat(lesson.additionalInfo.provider_full_id)"  v-model="lesson.additionalInfo.provider_full_id" rules="required" placeholder='Provider full id'/>
            <transition name="fade-fast">
              <span v-show="!meLessonFormat(lesson.additionalInfo.provider_full_id)" class="help is-danger">Wrong format</span>
            </transition>
            <span>Example: L1-U1-L1, L2-U3-L11, L5-U2-L4, etc.</span>
          </div>
        </div>
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Lesson Name</span>
          <div class="field">
            <bulma-input name="name" v-model="lesson.additionalInfo.name" rules="required" placeholder='Name'/>
          </div>
        </div>
        <div class="column is-6">
          <span class="heading has-text-grey-dark">Words (Vocabulary)</span>
          <div class="field">
            <bulma-input name="words" v-model="lesson.additionalInfo.words" rules="required" placeholder='Words'/>
          </div>
        </div>



        <div v-for="(property, index) in lesson.additionalInfo" class="column is-6" v-if="!excludeProperties.includes(index)">
          <span class="heading has-text-grey-dark">{{snakeToCamelCase(index)}}</span>
          <div class="field">
            <bulma-input  :name="index" v-model="lesson.additionalInfo[index]" rules="" :placeholder="snakeToCamelCase(index)"/>
          </div>
        </div>

        <!--
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="sentences" v-model="lesson.additionalInfo.sentences" rules="" placeholder='Sentence patterns'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="practice_words" v-model="lesson.additionalInfo.practice_words" rules="" placeholder='Practice words'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="other_key_words" v-model="lesson.additionalInfo.other_key_words" rules="" placeholder='Other key words'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="prop_ideas" v-model="lesson.additionalInfo.prop_ideas" rules="" placeholder='Prop ideas'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="role_play_slides" v-model="lesson.additionalInfo.role_play_slides" rules="" placeholder='Role play slides'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="game" v-model="lesson.additionalInfo.game" rules=""  placeholder='Game'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="show_time" v-model="lesson.additionalInfo.show_time" rules="" placeholder='Show time'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="crown_page" v-model="lesson.additionalInfo.crown_page" rules="" placeholder='Crown page'/>
                  </div>
                </div>
                <div class="column is-6">
                  <div class="field">
                    <bulma-input name="ending_song_length" v-model="lesson.additionalInfo.ending_song_length" rules="" placeholder='Ending song length'/>
                  </div>
                </div>-->

      </div>
      <!--<additional-info :additionalInfo="lesson.additionalInfo" @change="onChange"/>-->
      <div class="columns is-multiline">
        <div class="column is-2">
          <loading-button v-bind:loading="loading" color="is-info" @click="save()">Save</loading-button>
        </div>
        <div class="column is-2 is-offset-8 is-pulled-right">
          <a href="javascript:history.go(-1)" class="button is-block">
            Back
          </a>
        </div>
      </div>
    </form>
</template>

<script>

  import AdditionalInfo from './AdditionalInfo.vue'

  export default {
    name: 'me-lesson',
    components: {AdditionalInfo},
    props: {
      lessonForUpdate: { required: true },
      loading: { required: true, default: false },
    },
    data () {
      return {
        lesson: {},
        excludeProperties: ['id', 'name', 'words', 'provider_full_id', 'provider_id'],
      }
    },
    created () {
      this.lesson = Object.assign({}, this.lessonForUpdate);
      if(!this.lesson.id){
          this.lesson.additionalInfo  = this.meDefaultAdditionalInfo();
      }
  },
    methods: {
      save () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            if(!this.meLessonFormat(this.lesson.additionalInfo.provider_full_id) || !this.meLessonFormat(this.lesson.additionalInfo.provider_id, false)){
                return;
            }
            this.$emit('save', this.lesson);
          }
        })
      },

      onChange(additionalInfo){
      },
    },
    watch: {

        lessonForUpdate: function (lesson) {
            this.lesson = Object.assign({}, lesson);
        }

    }

  }
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sb-lessons/components/MELesson.vue